import { Component } from '@angular/core';

@Component({
  selector: 'app-congrat-resetpw-link-sent',
  standalone: false,
  templateUrl: './congrat-resetpw-link-sent.component.html',
  styleUrl: './congrat-resetpw-link-sent.component.scss'
})
export class CongratResetpwLinkSentComponent {

}
